<template>
  <v-container>
    <v-card>
      <v-row align="center" class="py-1 px-2" no-gutters>
        <v-col cols="12" sm="6">
          <v-breadcrumbs class="px-2" :items="breadcrumbsItems"></v-breadcrumbs>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          :class="$store.getters.LANGUAGE == 'fa' ? 'text-left' : 'text-right'"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                class="mx-2"
                v-bind="attrs"
                v-on="on"
                color="orange"
                @click="helpDialog = true"
              >
                <v-icon small>fa-question</v-icon>
              </v-btn>
            </template>
            <span>{{ $vuetify.lang.translator("showHelp") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-container>
        <v-form ref="form" v-model="valid" @submit.prevent="startUpload">
          <v-row align="center">
            <v-col cols="12" md="3">خط: {{ line_name }} </v-col>
            <v-col cols="12" md="2">
              عکس‌برداری: {{ capturedAt | moment("jYYYY/jM/jD") }}
            </v-col>
            <v-col cols="12" md="5" align-self="center">
              <label for="folders">
                یک پوشه انتخاب کنید:
                <v-icon style="float: left; cursor: pointer;" class="blue--text"
                  >fa-folder-plus</v-icon
                >
                <span
                  style="float: left; margin-left:5px;"
                  v-if="showSelectedFiles"
                  >{{ selectedFilesLabel }}</span
                >
              </label>
              <input
                type="file"
                id="folders"
                ref="folders"
                class="ltr-text"
                webkitdirectory
                directory
                multiple
                accept=".jpg,.jpeg,.png"
                v-on:change="updateSelectedFolder"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="primary"
                :loading="loading"
                :disabled="loading"
                block
                type="submit"
                v-if="!showReset"
              >
                <v-icon class="mx-2">fa-upload</v-icon>ارسال
              </v-btn>
              <v-btn
                color="primary"
                block
                :to="{ name: 'Upload' }"
                v-if="showReset"
              >
                ارسال جدید
              </v-btn>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col>
              <v-progress-linear
                v-model="uploadPercentage"
                height="25"
                striped
                color="light-blue"
                v-if="loading"
              >
                <strong
                  >{{ uploadPercentage }}% [{{ eachFilePercentage }}%]</strong
                >
              </v-progress-linear>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>

    <v-card class="mt-4">
      <v-data-table
        fixed-header
        :header-props="{ sortIcon: 'fas fa-sort-amount-up-alt' }"
        :headers="headers"
        :items="sentFilesStatus"
        :items-per-page="itemsPerPage"
        @update:items-per-page="updateRecordsPerPage"
        :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100] }"
        :dense="showDense"
        class="elevation-2"
      >
        <template v-slot:item.name="{ item }">
          <div class="ltr-text">
            {{ item.name }}
          </div>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip :color="getStatusColor(item.status)" dark small>
            {{ item.status }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      v-model="helpDialog"
      persistent
      max-width="800"
      @keydown.esc="helpDialog = false"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-toolbar dense elevation="2">
          <v-toolbar-title>{{
            $vuetify.lang.translator("help")
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="helpDialog = false">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <div
            class="mt-6"
            v-html="$vuetify.lang.translator('continueUploadHelp')"
          ></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="success" @click="helpDialog = false">{{
            $vuetify.lang.translator("gotIt")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style>
#folders {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
</style>

<script>
import { handleError } from "@/helpers/helper";

export default {
  name: "ContinueUpload",
  data: () => ({
    batch_id: 0,
    breadcrumbsItems: [
      { text: "میز کار", to: { name: "Dashboard" } },
      { text: "تصاویر ارسال شده", to: { name: "Uploads" } }
    ],
    valid: false,
    loading: false,
    showDense: false,
    showReset: false,
    itemsPerPage: 0,
    line_name: "",
    line_id: null,
    capturedAt: null,
    uploadPercentage: 0,
    eachFilePercentage: 0,
    totalSelectedFiles: 0,
    selectedFiles: [],
    selectedTowerFiles: [],
    showSelectedFiles: false,
    selectedFilesLabel: "",
    sentFiles: 0,
    sentTowerFiles: 0,
    sentFilesStatus: [],
    headers: [
      { text: "نام", value: "name" },
      { text: "وضعیت", value: "status" },
      { text: "توضیح", value: "message" }
    ],
    helpDialog: false
  }),
  created() {
    this.itemsPerPage = parseInt(this.$store.getters.PERPAGE);
    this.showDense = this.$store.getters.SHOWDENSE === "show";
    this.batch_id = this.$route.params.id;
    this.breadcrumbsItems.push({ text: "کد " + this.batch_id });
    this.breadcrumbsItems.push({
      text: "ادامه ارسال تصاویر",
      to: {
        name: "ContinueUpload",
        params: { id: this.batch_id }
      }
    });
    this.checkPrivileges();
    this.getBatch();
  },
  methods: {
    checkPrivileges() {
      let userType = parseInt(this.$store.getters.USERTYPE);
      let allowed_privileges = [3, 4, 5, 7];
      if (allowed_privileges.indexOf(userType) === -1) {
        this.$router.push({ name: "Error403" });
      }
    },
    getBatch() {
      var self = this;
      this.$http
        .get("/batch/" + self.batch_id + "/")
        .then(function(response) {
          self.line_name = response.data.line_name;
          self.line_id = response.data.line;
          self.capturedAt = response.data.captured_at;
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        });
    },
    startUpload() {
      if (this.selectedFiles.length === 0) {
        this.$toasted.error("یک پوشه انتخاب کنید", {
          duration: 5000,
          keepOnHover: true,
          className:
            self.$store.getters.LANGUAGE == "fa"
              ? "vazir-font-fd"
              : "vazir-font",
          iconPack: "fontawesome",
          icon: "exclamation-triangle",
          position: "top-center"
        });
        return;
      }
      this.loading = true;
      this.checkDuplication();
    },
    checkDuplication() {
      let data = {
        batch: this.batch_id,
        path: this.selectedFiles[this.sentFiles].path
      };
      var self = this;
      this.$http
        .post("/image/duplicate/", data)
        .then(function(response) {
          self.sendFile(response.data.duplicate);
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
          self.sendFile(false);
        });
    },
    sendFile(duplicated) {
      if (duplicated) {
        this.sentFilesStatus.unshift({
          name: this.selectedFiles[this.sentFiles].path,
          status: "تکراری",
          message: "ارسال نشد"
        });
        this.nextStep();
      } else {
        var formData = new FormData();
        formData.append("batch", this.batch_id);
        formData.append("line", this.line_id);
        formData.append(
          "original_file",
          this.selectedFiles[this.sentFiles].file
        );
        formData.append("file_path", this.selectedFiles[this.sentFiles].path);
        formData.append("folder", this.selectedFiles[this.sentFiles].folder);
        formData.append("tower", this.selectedFiles[this.sentFiles].tower);
        formData.append("tower_type", -1);
        this.eachFilePercentage = 0;
        let self = this;
        this.$http
          .post("/image/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: function(event) {
              self.eachFilePercentage = Math.round(
                (event.loaded * 100) / event.total
              );
            }
          })
          .then(() => {
            this.sentFilesStatus.unshift({
              name: this.selectedFiles[this.sentFiles].path,
              status: "موفق",
              message: "ارسال شد"
            });
          })
          .catch(error => {
            let result = handleError(
              error,
              self.$toasted,
              self.$router,
              self.$store
            );
            let messages = "";
            for (var item in result) {
              messages += result[item] + " ";
            }
            this.sentFilesStatus.unshift({
              name: this.selectedFiles[this.sentFiles].path,
              status: "خطا",
              message: messages
            });
          })
          .then(function() {
            self.nextStep();
          });
      }
    },
    nextStep() {
      this.sentFiles++;
      this.uploadPercentage = (
        (this.sentFiles / this.totalSelectedFiles) *
        100
      ).toFixed(0);
      if (this.sentFiles === this.selectedFiles.length) {
        this.sendTowerFile();
      } else {
        this.checkDuplication();
      }
    },
    sendTowerFile() {
      if (this.selectedTowerFiles.length == 0) {
        this.finishUpload();
        this.loading = false;
        this.showReset = true;
        this.$toasted.success("عملیات به اتمام رسید", {
          duration: 5000,
          keepOnHover: true,
          className:
            self.$store.getters.LANGUAGE == "fa"
              ? "vazir-font-fd"
              : "vazir-font",
          iconPack: "fontawesome",
          icon: "exclamation-triangle",
          position: "top-center"
        });
        return;
      }
      var formData = new FormData();
      formData.append("batch", this.batch_id);
      formData.append(
        "original_file",
        this.selectedTowerFiles[this.sentTowerFiles].file
      );
      formData.append(
        "folder",
        this.selectedTowerFiles[this.sentTowerFiles].folder
      );
      this.eachFilePercentage = 0;
      let self = this;
      this.$http
        .post("/folder/", formData, {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: function(event) {
            self.eachFilePercentage = Math.round(
              (event.loaded * 100) / event.total
            );
          }
        })
        .then(() => {
          this.sentFilesStatus.unshift({
            name: this.selectedTowerFiles[this.sentTowerFiles].path,
            status: "موفق",
            message: "ارسال شد"
          });
        })
        .catch(error => {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          let messages = "";
          for (var item in result) {
            messages += result[item] + " ";
          }
          this.sentFilesStatus.unshift({
            name: this.selectedTowerFiles[this.sentTowerFiles].path,
            status: "خطا",
            message: messages
          });
          self.uploading = false;
        })
        .then(function() {
          self.sentTowerFiles++;
          self.uploadPercentage = (
            ((self.sentFiles + self.sentTowerFiles) / self.totalSelectedFiles) *
            100
          ).toFixed(0);
          if (
            self.totalSelectedFiles ===
            self.sentFiles + self.sentTowerFiles
          ) {
            self.finishUpload();
            self.loading = false;
            self.showReset = true;
            self.$toasted.success("عملیات به اتمام رسید", {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          } else {
            self.sendTowerFile();
          }
        });
    },
    finishUpload() {
      let self = this;
      this.$http
        .get("/batch/" + this.batch_id + "/upload-finished/")
        .then(() => {})
        .catch(error => {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        });
    },
    updateSelectedFolder() {
      let canContinue = true;
      let validFiles = [];
      let towerFiles = [];
      let folderName = "";
      let allFiles = this.$refs.folders.files;
      let totalFiles = allFiles.length;
      for (var i = 0; i < totalFiles; i++) {
        let fn = allFiles[i].name.toLowerCase();
        if (
          fn.indexOf(".jpg") !== -1 ||
          fn.indexOf(".jpeg") !== -1 ||
          fn.indexOf(".png") !== -1
        ) {
          let fullPath = allFiles[i].webkitRelativePath;
          let pathItems = fullPath.split("/");
          if (pathItems.length === 4) {
            folderName = pathItems[0];
            validFiles.push({
              file: allFiles[i],
              path: fullPath,
              tower: pathItems[1],
              folder: pathItems[2]
            });
          } else if (pathItems.length === 3) {
            towerFiles.push({
              file: allFiles[i],
              path: fullPath,
              folder: pathItems[1]
            });
          } else {
            canContinue = false;
            this.$toasted.error("ساختار پوشه‌ها اشتباه است", {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
            break;
          }
        }
      }
      totalFiles = validFiles.length + towerFiles.length;
      if (totalFiles > 0 && canContinue) {
        this.selectedFilesLabel =
          "پوشه " + folderName + " با " + totalFiles + " فایل انتخاب شد";
        this.showSelectedFiles = true;
        this.selectedFiles = validFiles;
        this.selectedTowerFiles = towerFiles;
        this.totalSelectedFiles = totalFiles;
      } else {
        this.resetData();
      }
    },
    getStatusColor(status) {
      if (status == "خطا") return "red";
      else if (status == "تکراری") return "orange";
      else return "green";
    },
    resetData() {
      this.uploadPercentage = 0;
      this.totalSelectedFiles = 0;
      this.selectedFilesLabel = "";
      this.showSelectedFiles = false;
      this.selectedFiles = [];
      this.selectedTowerFiles = [];
      this.sentFiles = 0;
      this.sentTowerFiles = 0;
      this.sentFilesStatus = [];
      this.showReset = false;
    },
    updateRecordsPerPage(rowsPerPage) {
      this.$store.dispatch("saveRecordsPerPage", rowsPerPage);
    }
  }
};
</script>
